import React from 'react';
import AdContainer from 'src/components/ads';
import { useMobileTopAd } from 'src/hooks/experiments';

const MobileTopAd: React.VFC = () => {
  const showMobileAd = useMobileTopAd();
  return (
    <>
      {showMobileAd && (
        <AdContainer
          placement="dubbelpanorama1"
          min={0}
          max={860}
          format="panorama_1"
          spacing={{ top: '10px' }}
        />
      )}
    </>
  );
};

export default MobileTopAd;
